/**
 * Functions that return or update drive app data only.
 */

import { getAPIData } from "./axios";

// Getters
export async function getDriveURL() {
  const url = "/files/geturl";
  return await getAPIData(url);
}

export async function getFolderInfo(path) {
  path = encodeURIComponent(path);
  const url = `/files/getfolder/${path}`;
  return await getAPIData(url);
}

export async function getFileLink(path) {
  path = encodeURIComponent(path);
  const url = `/files/getfile/${path}`;
  return await getAPIData(url);
}

export async function getMetadata(entry_id) {
  const url = `/files/getmetadata/${entry_id}`;
  return await getAPIData(url);
}

export async function downloadFile(path) {
  path = encodeURIComponent(path);
  const url = `/files/downloadfile/${path}`;
  return await getAPIData(url);
}
